import { render } from "./WinNer.vue?vue&type=template&id=53b07696"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/WinNer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53b07696"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53b07696', __exports__)) {
    api.reload('53b07696', __exports__)
  }
  
  module.hot.accept("./WinNer.vue?vue&type=template&id=53b07696", () => {
    api.rerender('53b07696', render)
  })

}


export default __exports__